import {FC} from 'react';
import {useFormContext} from 'react-hook-form';

import {getRegisterRules} from '../utils';

type InputHiddenProps = {
    name: string;
    value?: string;
};

const InputHidden: FC<InputHiddenProps> = ({name, value}) => {
    const {register} = useFormContext();

    const registerRules = getRegisterRules({});

    return (
        <input {...register(name, registerRules)} type="hidden" value={value} />
    );
};

export default InputHidden;
